/**
 * @file WmsSkuThumb.tsx
 * @description Фото фасовки 56px в строке складского документа (phase19.24
 * этап 1, шаг 1).
 *
 * Первая колонка таблицы позиций и левый слот карточки — одна и та же
 * заглушка во всех четырёх документах. Без фото (`GET /admin/wms/receipts`,
 * `/writeoffs`, `/transfers` отдают фасовку без `imageUrl`) рисуем иконку
 * коробки: пустая ячейка ломала бы ритм строки.
 */

import { Package } from "lucide-react";

interface Props {
  /** Ссылка на фото фасовки; `null`/`undefined` — иконка-заглушка. */
  url?: string | null;
}

export function WmsSkuThumb({ url }: Props) {
  if (url) {
    return <img src={url} alt="" className="size-14 rounded-lg object-cover" />;
  }
  return (
    <span className="flex size-14 items-center justify-center rounded-lg bg-surface-low">
      <Package className="size-5 text-on-surface-variant" aria-hidden />
    </span>
  );
}
